<template>
  <div>
    <v-container>
      <v-layout wrap justify-end class="pt-4">
        <v-flex xs12 sm6 class="text-sm-right text-xs-right">
          <v-btn depressed color="primary" class="ma-0 mr-1" @click="showSearch = true">
            <v-icon>search</v-icon>&nbsp;{{ $t('Advanced Search') }}
          </v-btn>
          <v-btn dark outline color="primary" :loading="loading" @click="getXlsxData">
            <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <v-data-table
        hide-actions
        :loading="loading"
        :headers="headers"
        :items="employeeData"
        :pagination.sync="pagination"
        class="elevation-1 mt-3"
      >
        <template #items="props">
          <tr>
            <td>{{ `${props.item.fname} ${props.item.lname}` }}</td>
            <td>{{ props.item.department || '-' }}</td>
            <td>{{ props.item.affiliation || '-' }}</td>
            <td>{{ props.item.sop_30 ? 'Yes' : '-' }}</td>
            <td>{{ props.item.sop_60 ? 'Yes' : '-' }}</td>
            <td>{{ props.item.sop_90 ? 'Yes' : '-' }}</td>
            <td>
              {{
                props.item.headman_mame ? `${props.item.headman_mame} (${props.item.headman})` : '-'
              }}
            </td>
            <td>
              {{
                (props.item.supervisor_date ||
                  props.item.sop_30_date ||
                  props.item.sop_60_date ||
                  props.item.sop_90_date) | DateFormat('DD/MM/YYYY')
              }}
            </td>
            <td>{{ props.item.headman_comment || '-' }}</td>
            <td>{{ props.item.hr_name || '-' }}</td>
            <td>{{ props.item.approve_date | DateFormat('DD/MM/YYYY') }}</td>
            <td>{{ props.item.hr_manager_comment || '-' }}</td>
            <td>
              <v-select
                style="max-width: 160px; min-width: 100px"
                :value="mapSopToStatus(employeeData[props.index])"
                :items="['Proceeding', 'Pass', 'Fail']"
                hide-details
                :disabled="mapSopToStatus(employeeData[props.index]) === 'Pass'"
                @change="updateStatus(props.item, $event)"
              ></v-select>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div class="mt-2">
        <v-pagination
          v-model="pageNumber"
          :total-visible="6"
          :length="pagelength"
          @input="changePage"
        ></v-pagination>
      </div>

      <v-dialog v-model="showSearch" persistent width="850px">
        <SearchSopReport
          @close="onCloseSearch"
          @search="searchSop"
          @clear="clearSearch"
        ></SearchSopReport>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import hopinnHrApi from '@/api/hopinn-hr'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
import moment from 'moment'
import importxlsx from '@/components/elements/importxlsx.vue'
import SearchSopReport from './SearchSopReport.vue'

export default {
  components: {
    importxlsx,
    SearchSopReport
  },
  data() {
    return {
      limit: 10,
      offset: 0,
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      pagetmp: 1,
      pageNumber: 1,
      importloading: false,
      showSearch: false,
      loading: false,
      employeeData: [],
      filter: {
        status: '',
        registerdate_from: '',
        registerdate_to: '',
        expireddate_from: '',
        expireddate_to: '',
        brand: ''
      },
      catchFilter: {},
      headers: [
        { text: 'Staff Name', value: 'first_name' },
        { text: 'Department', value: 'department' },
        { text: 'Affiliation', value: 'affiliation' },
        { text: 'SOP 30 DAY', value: 'SOP_30_DAY' },
        { text: 'SOP 60 DAY', value: 'SOP_60_DAY' },
        { text: 'SOP 90 DAY', value: 'SOP_90_DAY' },
        { text: 'Department Head Name', value: 'department_head_Name' },
        { text: 'Department Head Approved Date', value: 'approve_date' },
        { text: "Department Head's comment", value: 'department_head_comment' },
        { text: 'HR Name', value: 'hr_name' },
        { text: 'HR Approved Date', value: 'hr_approve_date' },
        { text: 'HR Comment', value: 'hr_manager_comment' },
        { text: 'Status', value: 'status' }
      ],
      tags: [],
      isExport: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        var total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    onSearch(payload) {
      this.showSearch = false
      this.getData(payload)
    },
    onCloseSearch() {
      this.showSearch = false
    },
    async getXlsxData() {
      const vm = this
      vm.isExport = true
      const data = await vm.getData()
      vm.isExport = false
      vm.getData()

      if (data == null) return
      const report = data.map((el) => {
        return {
          staff_name: `${el.fname} ${el.lname}`,
          department: el.department,
          affiliation: el.affiliation,
          sop_30: el.sep_30 ? 'Yes' : '-',
          sop_60: el.sop_60 ? 'Yes' : '-',
          sop_90: el.sop_90 ? 'Yes' : '-',
          headman: el.headman_mame ? `${el.headman_mame} (${el.headman})` : '-',
          approve_date: el.approve_date ? moment(el.approve_date).format('DD/MM/YYYY') : '-',
          department_head_comment: el.department_head_comment ? el.department_head_comment : '-',
          hr_name: el.hr_name ? el.hr_name : '-',
          supervisor_date: el.supervisor_date
            ? moment(el.supervisor_date).format('DD/MM/YYYY')
            : '-',
          hr_manager_comment: el.hr_manager_comment ? el.hr_manager_comment : '-',
          status: el.status ? el.status : '-'
        }
      })

      const heading = [
        [
          'Staff Name',
          'Department',
          'Affiliation',
          'SOP 30 DAY',
          'SOP 60 DAY',
          'SOP 90 DAY',
          'Department Head Name',
          'Department Head Approved Date',
          "Department Head's comment",
          'HR Name',
          'HR Approved Date',
          'HR Comment',
          'Status'
        ]
      ]

      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet([])
      XLSX.utils.sheet_add_aoa(ws, heading)
      XLSX.utils.sheet_add_json(ws, report, { origin: 'A2', skipHeader: true })
      XLSX.utils.book_append_sheet(wb, ws)
      XLSX.writeFile(wb, `hopinn-sop-report.xlsx`)
    },
    clearSearch() {
      this.pagetmp = 1
      this.pageNumber = 1
      this.offset = 0
      this.catchFilter = {}
      this.onCloseSearch()
      this.getData()
    },
    searchSop(val) {
      const vm = this
      vm.offset = 0
      vm.catchFilter = val
      vm.onCloseSearch()
      vm.getData()
    },
    async getData() {
      const vm = this
      return new Promise(async (resolve, reject) => {
        const limit = vm.isExport ? vm.total : vm.limit
        let data = {
          pageid: vm.selectedBot.pageid,
          limit: limit,
          offset: vm.offset,
          ...this.catchFilter
        }

        vm.loading = true
        const response = await hopinnHrApi.getSopReport({
          config: {
            params: data
          }
        })
        vm.loading = false
        if (response && response.data.responsecode == 200) {
          vm.employeeData = response.data.data
          vm.total = response.data.total
          resolve(response.data.data)
        } else {
          reject(null)
        }
      })
    },
    updateStatus(item, evt) {
      this.updateSop(item.staffid, evt)
    },
    async updateSop(staffid, status) {
      const vm = this
      try {
        const data = {
          pageid: vm.selectedBot.pageid,
          manager_approve: vm.mapSopStatus(status),
          staffid
        }
        vm.loading = true
        const response = await hopinnHrApi.updateSopStatus({ data: data })
        vm.loading = false
        if (response && response.data.responsecode == 200) {
          vm.getData()
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    mapSopStatus(val) {
      let output = null
      switch (val) {
        case 'Pass':
        case 'pass':
          output = true
          break
        case 'Fail':
        case 'fail':
          output = false
          break
        case 'Proceeding':
        case 'proceeding':
          output = null
          break
      }
      return output
    },
    mapSopToStatus(employee) {
      const val = employee.manager_approve
      let output = 'Proceeding'
      switch (val) {
        case true:
          output = 'Pass'
          break
        case false:
          output = 'Fail'
          break
        case null:
          output = 'Proceeding'
          break
        default:
          output = 'Proceeding'
          break
      }
      if (employee.status && employee.status.toLowerCase() === 'hiring') output = 'Pass'
      return output
    },
    changePage(val) {
      const vm = this
      if (this.pagetmp !== val) {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getData()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/HopinnHr/SopReport.vue